import { openGenericModal } from "../util/generic-modal"

/**
 * Makes an AJAX-Request and checks, if the user have
 * the rights to be logged in and to see censored content.
 *
 * @param interval int time in microseconds,
 * how oft we should check user data in interval
 */
export function checkUserStatusAndUpdateCensoredImagesRights(interval: number) {
    setInterval(async () => {
        const data = await fetch("/api/checkUserStatus", {
            method: "GET",
            mode: "cors",
            credentials: "include",
        })
        const jsonData = await data.json()
        if (!jsonData.loggedIn) {
            await openReloadModal()
        }
    }, interval)
}

async function openReloadModal() {
    const loggedOutModal = openGenericModal(
        "Du bist nicht mehr angemeldet. Versuche bitte dich neu anzumelden.",
        "Sitzung abgelaufen",
    )
    const genericDialogCloseButton = loggedOutModal.querySelector("#generic-dialog-close-button")

    genericDialogCloseButton?.addEventListener("click", () => {
        window.scroll({ top: 0, behavior: "smooth" })
        window.location.reload()
    })
}
